module.exports = "/images/wind@3x.png?bda344dd875cb15e0075d5f0ded7f594";